import {  Component, QueryList, ViewChildren,} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from '../../../services/data/data.service';

import { FiltersM, typesApex } from '../../../components/models';
import { formatear, } from '../../funciones/funcionesGenerales';
import { Aligment, ExcelService, FormatText } from '../../../services/excel/excel.service';
import { messages } from '../../funciones/mensajes';
import { ConstantesImagenes } from '../../../models/Cuestionarios/codigoimagenes';
import Swal from 'sweetalert2';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.addVirtualFileSystem(pdfFonts);
import { firstValueFrom } from 'rxjs';
import { ComercialService, PERIODICITY, PerspectiveIdentifier } from '../../../services/comercial/comercial.service';
import { Meses } from '../../../models/Formulacion/indicadores-metas/datos';

type ZonaConfig = {
  perspectiveIndex: number;
  dataKey: 'data1' | 'data2' | 'data3' | 'data4' | 'data5' | 'data6';
  labelsKey: 'labels1' | 'labels2' | 'labels3' | 'labels4' | 'labels5' | 'labels6';
  tituloKey: 'tituloZona1' | 'tituloZona2' | 'tituloZona3' | 'tituloZona4' | 'tituloZona5' | 'tituloZona6';
  axisYKey: 'axisY1' | 'axisY2' | 'axisY3' | 'axisY4' | 'axisY5' | 'axisY6';
  name: string;
};

/** Estado de cada gráfica de la pantalla: tipo actual, etiquetas, modal y tipos disponibles en su menú. */
type GraficoPerfil = {
  zona: number;
  type: string;
  tipoInicial: string;
  etiquetas: boolean;
  ampliado: boolean;
  tipos: string[];
};

/** Tabla de una gráfica: valores y % por categoría, con el total al final. */
type TablaPerfil = {
  name: string;
  valores: number[];
  porcentaje: number[];
};

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrl: './perfil.component.css'
})
export class PerfilComponent {
  @ViewChildren(GraficadorComponent) grafComp!: QueryList<GraficadorComponent>;
  private pdfFile: any;
  public types = typesApex;

  // Colores oficiales, reordenados para que 2-3 categorías no salgan solo en azul.
  public paleta = ['#5EAEE5', '#A4D55D', '#FFE370', '#8AD2E6', '#FFAE5F', '#FB7598', '#7C8FD6', '#B7B7B7'];
  zonas = [];
  consolidadoZona = true;
  sucursales = [];
  consolidado = true;
  filters = {};

  public Filters = FiltersM;
  selectedYears = [];
  selectedMonths: number[] = [0];
  yearsInput: number[] = [0];

  yearsAvailable: any[];
  monthOfYearAvailable: any[];
  monthAvailable: any[];
  yearMonthSelected: string = '';

  subtitles = '';
  perspectives: any[] = ['','','','','',''];
  // Mismo orden que las llamadas en getData(), una por gráfica.
  private readonly graphPerspectiveNames = ['Género', 'Edad', 'Generación', 'Nivel educación', 'Ocupación', 'Estado civil'];
  tituloZona1 = '';
  data1 = [];
  labels1 = [];
  axisY1 = [];
  graphics1 = [typesApex.DONUT, typesApex.AREA, typesApex.BAR, typesApex.LINE, typesApex.TABLE];
  zona1 = 1;
  tituloZona2 = '';
  data2 = [];
  labels2 = [];
  axisY2 = [];
  graphics2 = [typesApex.DONUT, typesApex.AREA, typesApex.BAR, typesApex.LINE, typesApex.TABLE];
  zona2 = 2;
  tituloZona3 = '';
  data3 = [];
  labels3 = [];
  axisY3 = [];
  graphics3 = [typesApex.DONUT, typesApex.AREA, typesApex.BAR, typesApex.LINE, typesApex.TABLE];
  zona3 = 3;
  tituloZona4 = '';
  data4 = [];
  labels4 = [];
  axisY4 = [];
  graphics4 = [typesApex.DONUT, typesApex.AREA, typesApex.BAR, typesApex.LINE, typesApex.TABLE];
  zona4 = 4;
  tituloZona5 = '';
  data5 = [];
  labels5 = [];
  axisY5 = [];
  graphics5 = [typesApex.DONUT, typesApex.AREA, typesApex.BAR, typesApex.LINE, typesApex.TABLE];
  zona5 = 5;
  tituloZona6 = '';
  data6 = [];
  labels6 = [];
  axisY6 = [];
  graphics6 = [typesApex.DONUT, typesApex.AREA, typesApex.BAR, typesApex.LINE, typesApex.TABLE];
  zona6 = 6;

  /** Orden de los tipos en el submenú «Gráficas» y su icono / texto. */
  private readonly ordenTipos: string[] = [typesApex.BAR, typesApex.LINE, typesApex.AREA, typesApex.DONUT, typesApex.HEATMAP, typesApex.TABLE];
  public readonly infoTipos: Record<string, { icono: string, texto: string }> = {
    [typesApex.BAR]: { icono: 'bar_chart', texto: 'graf.barras' },
    [typesApex.LINE]: { icono: 'show_chart', texto: 'graf.lineal' },
    [typesApex.AREA]: { icono: 'area_chart', texto: 'graf.area' },
    [typesApex.DONUT]: { icono: 'pie_chart', texto: 'graf.pie' },
    [typesApex.HEATMAP]: { icono: 'view_quilt', texto: 'graf.calor' },
    [typesApex.TABLE]: { icono: 'table_chart', texto: 'graf.tabla' },
  };
  private crearGrafico(zona: number, type: string, tipos: string[]): GraficoPerfil{
    return {
      zona,
      type,
      tipoInicial: type,
      etiquetas: true,
      ampliado: false,
      tipos: this.ordenTipos.filter(t => tipos.includes(t)),
    };
  }
  public graficos: GraficoPerfil[] = [
    this.crearGrafico(1, typesApex.DONUT, this.graphics1),
    this.crearGrafico(2, typesApex.HEATMAP, this.graphics2),
    this.crearGrafico(3, typesApex.DONUT, this.graphics3),
    this.crearGrafico(4, typesApex.BAR, this.graphics4),
    this.crearGrafico(5, typesApex.DONUT, this.graphics5),
    this.crearGrafico(6, typesApex.BAR, this.graphics6),
  ];
  /** Dos filas de tres gráficas, como se acomodan en pantalla. */
  public filasGraficos: GraficoPerfil[][] = [this.graficos.slice(0, 3), this.graficos.slice(3, 6)];
  /** Tabla de cada gráfica (índice = zona - 1), se arma al traer los datos. */
  public tablaZona: TablaPerfil[] = [];

  private token;
  Perspectives = [
    {identifier: PerspectiveIdentifier.GENDER, name: 'Género'},
    {identifier: PerspectiveIdentifier.AGE_RANGE, name: 'Edad'},
    {identifier: PerspectiveIdentifier.GENERATION, name: 'Generación'},
    {identifier: PerspectiveIdentifier.MARITAL_STATUS, name: 'Estado civil'},
    {identifier: PerspectiveIdentifier.PROFESSION, name: 'Ocupación'},
    {identifier: PerspectiveIdentifier.ECONOMIC_ACTIVITY, name: 'Actividad Economica'},
    {identifier: PerspectiveIdentifier.EDUCATION_LEVEL, name: 'Nivel educación'},
    {identifier: PerspectiveIdentifier.MUNICIPALITY, name: 'Munucipio'},
    {identifier: PerspectiveIdentifier.MEMBER_STATUS, name: 'Estatus'},
    {identifier: PerspectiveIdentifier.BRANCH_OFFICE, name: 'Sucursales'},
  ]
  periodicidad = [
    {name: 'Mensual', check: false, value: 1},
    {name: 'Bimestral', check: false, value: 2},
    {name: 'Semestral', check: true, value: 6},
    {name: 'Anual', check: false, value: 12},
  ];

    monthSelect = false;


  constructor(
    public dataService: DataService,
    public translate: TranslateService,
    public excel: ExcelService,
    private readonly comercialService: ComercialService,
  ) {
    formatear.momentAbrev();
    this.getPeriodos();
  }
  private async getPeriodos(){
    const token = await firstValueFrom(this.comercialService.loginOdefFinanciera());
    this.token = token['accessToken'];

    const periodos = await firstValueFrom(
      this.comercialService.getPeriodosCreditos(this.token)
    );

    const auxYear = [];
    const auxMounts = [];
    this.comercialService.ordenarPeriodos(periodos['periods']).forEach(y => {
      auxYear.push({
        anio: y.year,
        name: `${y.year}`,
        check: false,
      });
      y.months.forEach(m => {
        auxMounts.push({
          name: Meses.getMesesNumbertoString(m, true),
          check: false,
          an: y.year,
          periodo: `${Meses.getMesesNumbertoString(m, true)}-${(''+y.year).substring(2)}`,
        });
      });
    });

    this.yearsAvailable = auxYear;
    this.monthAvailable = auxMounts;

    await this.seleccionarPeriodoConDatos();

    await this.getZonas();

    this.getData();
  }
  /** Busca del periodo más reciente al más antiguo el primero con datos reales de socios. */
  private async seleccionarPeriodoConDatos(soloAnio?: number){
    const candidatos = soloAnio !== undefined
      ? this.monthAvailable.filter(m => m.an === soloAnio)
      : this.monthAvailable;

    for(let i = candidatos.length - 1; i >= 0; i--){
      const mes = candidatos[i];
      const periodo = `${mes.an}-${Meses.getMesesNum(mes.name)}`;

      try{
        const data = await firstValueFrom(
          this.comercialService.getCuentas({
            perspective: PerspectiveIdentifier.GENDER,
            period: periodo,
            granularity: PERIODICITY.MONTH
          }, this.token)
        );
        if(data['results']?.length > 0){
          this.yearsAvailable.forEach(y => y.check = (y.anio === mes.an));
          this.monthAvailable.forEach(m => m.check = false);
          mes.check = true;
          this.monthOfYearAvailable = this.monthAvailable.filter(m => m.an === mes.an);
          return;
        }
      }catch{
        // Si falla ese periodo en particular, seguimos probando con el anterior.
      }
    }

    // Respaldo: si ningún periodo tuvo datos, se deja marcado el más reciente del conjunto.
    const respaldoAnio = soloAnio ?? this.yearsAvailable[this.yearsAvailable.length-1].anio;
    this.yearsAvailable.forEach(y => y.check = (y.anio === respaldoAnio));
    const months = this.monthAvailable.filter( m => m.an === respaldoAnio );
    months.forEach(m => m.check = false);
    months[months.length-1].check = true;
    this.monthOfYearAvailable = months;
  }
  /** Trae las zonas y sucursales reales de ODEF, con el mismo token que las gráficas de socios. */
  private async getZonas(){
    try{
      const per = this.getPeriodo();

      const data = await firstValueFrom(
        this.comercialService.getCreditoA1({
          perspective: PerspectiveIdentifier.REGION,
          period: per,
          granularity: PERIODICITY.MONTH
        }, this.token)
      );
      const regionesDes = data['results'];
      const regiones = regionesDes.sort((a, b) => {
        if (a.description === 'SIN REGION') return 1;
        if (b.description === 'SIN REGION') return -1;
        return a.description.localeCompare(b.description, 'es', { sensitivity: 'base' });
      });

      const zonas = [];
      for(const r of regiones){
        const filters = { [PerspectiveIdentifier.REGION]: [r.code] };
        const sucData = await firstValueFrom(
          this.comercialService.getCreditoA1({
            perspective: PerspectiveIdentifier.BRANCH_OFFICE,
            period: per,
            granularity: PERIODICITY.MONTH,
            filters
          }, this.token)
        );
        const sucursalesZona = sucData['results']
          .sort((a, b) => a.description.localeCompare(b.description, 'es'))
          .map(s => ({ name: formatear.capitalizar(s.description), code: s.code, check: false }));

        zonas.push({
          name: formatear.capitalizar(r.description),
          code: r.code,
          check: false,
          sucursales: sucursalesZona
        });
      }

      this.zonas = zonas;
      this.consolidadoZona = true;
      this.actualizarSucursalesPorZona();
    }catch(error){
    }
  }
  /** Llena el filtro de sucursales según la zona seleccionada (o todas, si no hay zona elegida) */
  private actualizarSucursalesPorZona(){
    if(this.consolidadoZona){
      this.sucursales = this.zonas.flatMap(z => z.sucursales.map(s => ({...s, check: false})));
    }else{
      const zonaSeleccionada = this.zonas.find(z => z.check);
      this.sucursales = zonaSeleccionada
        ? zonaSeleccionada.sucursales.map(s => ({...s, check: false}))
        : [];
    }
    this.consolidado = true;
  }
  private readonly zonaConfigs: ZonaConfig[] = [
    { perspectiveIndex: 0, dataKey: 'data1', labelsKey: 'labels1', tituloKey: 'tituloZona1', axisYKey: 'axisY1', name: 'Género' },
    { perspectiveIndex: 1, dataKey: 'data2', labelsKey: 'labels2', tituloKey: 'tituloZona2', axisYKey: 'axisY2', name: 'Edad' },
    { perspectiveIndex: 2, dataKey: 'data3', labelsKey: 'labels3', tituloKey: 'tituloZona3', axisYKey: 'axisY3', name: 'Generación' },
    { perspectiveIndex: 3, dataKey: 'data4', labelsKey: 'labels4', tituloKey: 'tituloZona4', axisYKey: 'axisY4', name: 'Nivel educación' },
    { perspectiveIndex: 4, dataKey: 'data5', labelsKey: 'labels5', tituloKey: 'tituloZona5', axisYKey: 'axisY5', name: 'Ocupación' },
    { perspectiveIndex: 5, dataKey: 'data6', labelsKey: 'labels6', tituloKey: 'tituloZona6', axisYKey: 'axisY6', name: 'Estado civil' },
  ];
  /** Categorías que se ven por default; el graficador agrupa el resto en "Otros" (agruparCategoriasExcedentes). */
  public readonly maxCategoriasPorDefecto = 10;
  private getData() {
    this.zonaConfigs.forEach(config => this.setZonaData(config));
    this.getSubtitles();
  }
  /** Por gráfica: true mientras se piden sus datos (se muestra el esqueleto de carga). */
  public cargando: boolean[] = [true, true, true, true, true, true];
  private async setZonaData(config: ZonaConfig) {
    this.cargando[config.perspectiveIndex] = true;
    try{
      await this.fetchZonaData(config);
    }finally{
      this.cargando[config.perspectiveIndex] = false;
    }
  }
  /** Por gráfica: true = se está mostrando todo (sin agrupar en "Otros"). */
  public verTodoActivo: boolean[] = [false, false, false, false, false, false];
  public hayMasCategorias: boolean[] = [false, false, false, false, false, false];
  /** "Mostrar todo"/"Mostrar solo los principales" del menú: el graficador agrupa o no el resto en "Otros". */
  public mostrarTodo(zonaNumero: number){
    this.verTodoActivo[zonaNumero - 1] = !this.verTodoActivo[zonaNumero - 1];
  }
  private async fetchZonaData(config: ZonaConfig) {
    const perspective = this.Perspectives.find(p => config.name === p.name);
    if(!perspective){
      return;
    }

    // El clic en una gráfica filtra en cadena a las gráficas siguientes:
    // cada gráfica hereda las selecciones hechas en las gráficas anteriores a ella.
    const filter = {}
    this.perspectives.slice(0, config.perspectiveIndex).forEach( f => {
      if(f){
        const per: PerspectiveIdentifier = this.Perspectives.find(p => f.filter === p.name).identifier;
        filter[per] = [Number(f.code)]
      }
    });

    if(!this.consolidado){
      const sucursalSelect = this.sucursales.find(s => s.check);
      if(sucursalSelect){
        filter[PerspectiveIdentifier.BRANCH_OFFICE] = [Number(sucursalSelect['code'])];
      }
    }else if(!this.consolidadoZona){
      // Se eligió una zona pero ninguna sucursal en particular: se filtra por la zona completa.
      const zonaSeleccionada = this.zonas.find(z => z.check);
      if(zonaSeleccionada){
        filter[PerspectiveIdentifier.REGION] = [Number(zonaSeleccionada['code'])];
      }
    }

    const per = this.getPeriodo();

    const data = await firstValueFrom(
      this.comercialService.getCuentas({
        perspective: perspective.identifier,
        period: per,
        granularity: PERIODICITY.MONTH,
        filters: filter
      },this.token)
    );

    this.hayMasCategorias[config.perspectiveIndex] = data['results'].length > this.maxCategoriasPorDefecto;

    const codes: number[] = [];
    const labels: string[] = [];
    const values: number[] = [];

    data['results'].forEach(item => {
      codes.push(item.code);
      labels.push(item.description);
      values.push(item.measures.activeCount);
    }); 
    

    this[config.dataKey] = [{
      name: config.name,
      data: values,
      extra: codes
    }];

    this.tablaZona[config.perspectiveIndex] = this.armarTabla(config.name, values);

    this[config.labelsKey] = labels;
    this[config.tituloKey] = config.name;
    this[config.axisYKey] = [config.name];
  }
  /** Valores y % de cada categoría, con el total al final (vista de tabla y exportaciones). */
  private armarTabla(name: string, values: number[]): TablaPerfil{
    const total = Number(values.reduce((suma, valor) => suma + valor, 0).toFixed(1));
    const porcentaje = total === 0
      ? values.map(() => 0)
      : values.map(valor => parseFloat(((valor / total) * 100).toFixed(2)));
    return {
      name,
      valores: [...values, total],
      porcentaje: [...porcentaje, 100],
    };
  }
  private getSubtitles(){
    const an = this.yearsAvailable.find(y => y.check === true).name.substring(2,4);
    const mes = this.monthOfYearAvailable.find(m => m.check === true).name;
    const fecha = `${mes} ${an}`;

    // Nivel geográfico: Agencia implica su Zona (igual que en metas); "Consolidado" si no hay nada filtrado.
    const zonaSeleccionada = this.zonas.find(z => z.check);
    const sucursalSeleccionada = this.sucursales.find(s => s.check);
    let nivelGeografico = this.translate.instant('comercial.asosiatividad.perfil.consolidado');
    if(!this.consolidado && sucursalSeleccionada){
      const zonaDeSucursal = this.zonas.find(z => z.sucursales.some(s => s.code === sucursalSeleccionada['code'])) ?? zonaSeleccionada;
      nivelGeografico = zonaDeSucursal ? `${zonaDeSucursal.name} | ${sucursalSeleccionada.name}` : sucursalSeleccionada.name;
    }else if(!this.consolidadoZona && zonaSeleccionada){
      nivelGeografico = zonaSeleccionada.name;
    }

    // Selecciones acumuladas de todas las gráficas (ej. "Femenino"): se muestran igual en las 6.
    const seleccionadas = this.perspectives.filter(p => !!p).map(p => p.name);

    const partes = [...seleccionadas, nivelGeografico].join(' | ');
    this.subtitles = `${partes} · ${fecha}`;
  }
  private getPeriodo(){
    const an = this.yearsAvailable.find(y => y.check === true).name;
    const mes = Meses.getMesesNum(this.monthOfYearAvailable.find(m => m.check === true).name)

    return `${an}-${mes}`;
  }
  clickGrafic(event: any, zona: number) {
    if(zona-1 === 0 || this.perspectives[zona-2] !== ''){
      // El graficador puede agrupar y reordenar (Otros), por eso se busca el código por nombre
      let posicion = this.datosDe(zona, 'labels').indexOf(event.name);
      if(posicion === -1 && event.name === undefined){
        posicion = event.posValue;
      }
      if(posicion === -1){
        return;
      }
      const codes = (this as any)['data' + zona]?.[0]?.extra;
      const code = codes ? codes[posicion] : undefined;
      this.perspectives[zona-1] = {
        name: event.name,
        filter: this.graphPerspectiveNames[zona-1],
        code
      };
      this.getData();
    }
  }
  async yearChange(year){
    await this.seleccionarPeriodoConDatos(year.anio);
    this.getData();
  }
  monthChange(mes){
    for(const m of this.monthOfYearAvailable){
      if(m.name === mes.name){
        m.check = true;
      }else{
        m.check = false;
      }
    }
    this.getData();
  }
  zonaChange(zonaClick: any){
    for(const z of this.zonas){
      if(zonaClick !== 'consolidado' && z.name === zonaClick.name){
        z.check = true;
      }else{
        z.check = false;
      }
    }
    if(zonaClick === 'consolidado'){
      this.consolidadoZona = !this.consolidadoZona;
    }else{
      this.consolidadoZona = false;
    }
    this.actualizarSucursalesPorZona();
    this.getData();
  }
  agencyChange(sucClick: any){
    for(const suc of this.sucursales){
      if(sucClick !== 'consolidado' && suc.name === sucClick.name){
        suc.check = true;
      }else{
        suc.check = false;
      }
    }
    if(sucClick === 'consolidado'){
      this.consolidado = !this.consolidado;
    }else{
      this.consolidado = false;
    }
    this.getData();
  }

  async resetFilters(){
    this.perspectives = ['','','','','',''];
    this.verTodoActivo = [false, false, false, false, false, false];
    await this.seleccionarPeriodoConDatos();
    this.consolidadoZona = true;
    this.zonas.forEach(z => z.check = false);
    this.actualizarSucursalesPorZona();
    this.graficos.forEach(g => g.type = g.tipoInicial);
    this.getData();
  }
  periodicityChange(event: any) {
    this.periodicidad.forEach( p => {
      if(p.value === event.value){
        p.check = true;
      }else{
        p.check = false;
      }
    });
    this.getData();
  }
  public exportarExcelSucursales() {
      try {
          const datosZona1 = this.obtenerZona1(); 
          const datosZona2 = this.obtenerZona2();
          const datosZona3 = this.obtenerZona3();
          const datosZona4 = this.obtenerZona4();
          const datosZona5 = this.obtenerZona5(); 
          const datosZona6 = this.obtenerZona6(); 

          const convertirData = (datos: any) => {
              if (!datos || !datos.data || datos.data.length === 0) {
                  return [];
              }
              return datos.data.map((obj: any) => 
                  datos.headers.map((key: string) => obj[key])
              );
          };

          const allDataSources = [datosZona1, datosZona2, datosZona3, datosZona4, datosZona5, datosZona6];

          const dataFilas: any[][] = allDataSources
              .map(ds => convertirData(ds))
              .filter(data => data.length > 0); 

          const encabezados: string[][] = allDataSources
              .filter(ds => ds.data.length > 0) 
              .map(ds => ds.headers);
          
          const formatoDecimal = ['@', '0.0', '0.00%']; 
          const formatoEntero = ['@', '#,##0', '0.00%'];
          
          const allFormats = [
              formatoDecimal,
              formatoDecimal,
              formatoDecimal,
              formatoEntero,
              formatoDecimal,
              formatoDecimal
          ];

          const formatos: string[][] = allFormats.filter((_, index) =>
              allDataSources[index] && allDataSources[index].data.length > 0
          );

          // Una alineación por tabla, en el mismo orden que encabezados/dataFilas.
          const alineacionesTablaGenerica: ('left' | 'center' | 'right')[] = ['left', 'right', 'right'];
          const alineaciones: ('left' | 'center' | 'right')[][] = Array(dataFilas.length).fill(alineacionesTablaGenerica);

          const tituloReporte = `${this.translate.instant('menu.'+this.dataService.moduleSelect)} * ${this.translate.instant('menu.'+this.dataService.subModuleSelect)}`;
          const nombreArchivo = 'Tabla_Perfil_Completo';

          this.excel.generateSucursalesAll(
              tituloReporte,
              encabezados,
              dataFilas,
              nombreArchivo,
              formatos,
              alineaciones
          );

      } catch (error) {
      }
  }
  private obtenerZona1() {
      const labels = this.labels1; 
      const serieName = this.data1.length > 0 ? this.data1[0].name : this.translate.instant('comercial.asosiatividad.perfil.valores');
      const valores = this.data1.length > 0 ? this.data1[0].data : [];

      const total = valores.reduce((sum, current) => sum + current, 0);

      const tableData = labels.map((label, index) => {
          const valor = valores[index];
          const porcentaje = total > 0 ? (valor / total) * 100 : 0;
          
          return {
              [this.translate.instant('comercial.asosiatividad.perfil.categoria')]: label,
              [serieName]: valor,
              '%': porcentaje
          };
      });

      tableData.push({
          [this.translate.instant('comercial.asosiatividad.perfil.categoria')]: this.translate.instant('comercial.asosiatividad.perfil.total'),
          [serieName]: total,
          '%': 100 
      });

      const tableHeaders = [this.translate.instant('comercial.asosiatividad.perfil.categoria'), serieName, '%'];

      return {
          headers: tableHeaders,
          data: tableData
      };
  }
  private obtenerZona2() {
      const labels = this.labels2; 
      const serieName = this.data2.length > 0 ? this.data2[0].name : this.translate.instant('comercial.asosiatividad.perfil.valores');
      const valores = this.data2.length > 0 ? this.data2[0].data : [];

      const total = valores.reduce((sum, current) => sum + current, 0);

      const tableData = labels.map((label, index) => {
          const valor = valores[index];
          const porcentaje = total > 0 ? (valor / total) : 0; 
          
          return {
              [this.translate.instant('comercial.asosiatividad.perfil.categoria')]: label,
              [serieName]: valor,
              '%': porcentaje
          };
      });

      tableData.push({
          [this.translate.instant('comercial.asosiatividad.perfil.categoria')]: this.translate.instant('comercial.asosiatividad.perfil.total'),
          [serieName]: total,
          '%': 1
      });

      const tableHeaders = [this.translate.instant('comercial.asosiatividad.perfil.categoria'), serieName, '%'];

      return {
          headers: tableHeaders,
          data: tableData
      };
  }
  private obtenerZona3() {
      const labels = this.labels3; 
      const serieName = this.data3.length > 0 ? this.data3[0].name : this.translate.instant('comercial.asosiatividad.perfil.valores');
      const valores = this.data3.length > 0 ? this.data3[0].data : [];

      const total = valores.reduce((sum, current) => sum + current, 0);

      const tableData = labels.map((label, index) => {
          const valor = valores[index];
          const porcentaje = total > 0 ? (valor / total) : 0; 
          
          return {
              [this.translate.instant('comercial.asosiatividad.perfil.categoria')]: label,
              [serieName]: valor,
              '%': porcentaje
          };
      });

      tableData.push({
          [this.translate.instant('comercial.asosiatividad.perfil.categoria')]: this.translate.instant('comercial.asosiatividad.perfil.total'),
          [serieName]: total,
          '%': 1
      });

      const tableHeaders = [this.translate.instant('comercial.asosiatividad.perfil.categoria'), serieName, '%'];

      return {
          headers: tableHeaders,
          data: tableData
      };
  }
  private obtenerZona4() {
      if (!this.data4 || this.data4.length === 0) {
          return {
              headers: [this.translate.instant('comercial.asosiatividad.perfil.categoria'), this.translate.instant('comercial.asosiatividad.perfil.valores'), '%'],
              data: [] 
          };
      }
      const labels = this.labels4; 
      const serieName = this.data4.length > 0 ? this.data4[0].name : this.translate.instant('comercial.asosiatividad.perfil.valores');
      const valores = this.data4.length > 0 ? this.data4[0].data : [];

      const total = valores.reduce((sum, current) => sum + current, 0);

      const tableData = labels.map((label, index) => {
          const valor = valores[index];
          const porcentaje = total > 0 ? (valor / total) : 0; 
          
          return {
              [this.translate.instant('comercial.asosiatividad.perfil.categoria')]: label,
              [serieName]: valor,
              '%': porcentaje
          };
      });

      tableData.push({
          [this.translate.instant('comercial.asosiatividad.perfil.categoria')]: this.translate.instant('comercial.asosiatividad.perfil.total'),
          [serieName]: total,
          '%': 1 
      });

      const tableHeaders = [this.translate.instant('comercial.asosiatividad.perfil.categoria'), serieName, '%'];

      return {
          headers: tableHeaders,
          data: tableData
      };
  }
  private obtenerZona5() {
      const labels = this.labels5; 
      const serieName = this.data5.length > 0 ? this.data5[0].name : this.translate.instant('comercial.asosiatividad.perfil.valores');
      const valores = this.data5.length > 0 ? this.data5[0].data : [];

      const total = valores.reduce((sum, current) => sum + current, 0);

      const tableData = labels.map((label, index) => {
          const valor = valores[index];
          const porcentaje = total > 0 ? (valor / total) : 0; 
          
          return {
              [this.translate.instant('comercial.asosiatividad.perfil.categoria')]: label,
              [serieName]: valor,
              '%': porcentaje
          };
      });

      tableData.push({
          [this.translate.instant('comercial.asosiatividad.perfil.categoria')]: this.translate.instant('comercial.asosiatividad.perfil.total'),
          [serieName]: total,
          '%': 1 
      });

      const tableHeaders = [this.translate.instant('comercial.asosiatividad.perfil.categoria'), serieName, '%'];

      return {
          headers: tableHeaders,
          data: tableData
      };
  }
  private obtenerZona6() {
      const labels = this.labels6; 
      const serieName = this.data6.length > 0 ? this.data6[0].name : this.translate.instant('comercial.asosiatividad.perfil.valores');
      const valores = this.data6.length > 0 ? this.data6[0].data : [];

      const total = valores.reduce((sum, current) => sum + current, 0);

      const tableData = labels.map((label, index) => {
          const valor = valores[index];
          const porcentaje = total > 0 ? (valor / total) : 0; 
          
          return {
              [this.translate.instant('comercial.asosiatividad.perfil.categoria')]: label,
              [serieName]: valor,
              '%': porcentaje
          };
      });

      tableData.push({
          [this.translate.instant('comercial.asosiatividad.perfil.categoria')]: this.translate.instant('comercial.asosiatividad.perfil.total'),
          [serieName]: total,
          '%': 1 
      });

      const tableHeaders = [this.translate.instant('comercial.asosiatividad.perfil.categoria'), serieName, '%'];

      return {
          headers: tableHeaders,
          data: tableData
      };
  }

  async exportarPDF(){
    try{
      messages.messageSaving(this.translate.instant('acciones.descarga'),this.translate.instant('acciones.espera'))

      const fechaPiePag = new Date().toLocaleDateString('es-MX', {month: '2-digit',day: '2-digit',year: '2-digit',});
      const horaPiePag = new Date().toLocaleTimeString('es-MX');
      const currentUser = this.dataService.user;

      const docPDF = {
        pageSize: 'FOLIO',
        images: {
          logoAleema: ConstantesImagenes.fondoblanco,
        },
        footer: function (currentPage, pageCount){
          if(currentPage == 1){
            return null;
          }
          if(currentPage === pageCount){
            return{
              columns: [
                {
                  image: 'logoAleema',
                  width: 70,
                  margin: [30, -1, 30, 0],
                },
                {
                  text: `${currentUser}  |  ${fechaPiePag}  |  ${horaPiePag}`,
                  alignment: 'center',
                  width: '*',
                  color: '#808080',
                  fontSize: 10,
                },

                {
                  text: (currentPage - 1).toString(),
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                  margin: [10, -1, 30, 0],
                },
              ]
            }
          }else{
            return{
              text: {
                  text: (currentPage - 1).toString(),
                  alignment: 'right',
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                },margin: [10, -1, 30, 0],
            }
          }
        },
        content: [
          await this.generateZonaPDF(this.zona1),
          await this.generateZonaPDF(this.zona2),
          await this.generateZonaPDF(this.zona3),
          await this.generateZonaPDF(this.zona4),
          await this.generateZonaPDF(this.zona5),
          await this.generateZonaPDF(this.zona6),
        ]
      }

      var reportName = 'Reporte general';
      const pdf = pdfMake.createPdf(docPDF);
      
      pdf.download(reportName);
      const blob = await pdf.getBlob();
      this.pdfFile = blob;

      Swal.close();
      messages.succesMessageGraph(this.translate.instant('acciones.desExito'))
    }catch(error){
      Swal.close();
      Swal.fire({title: this.translate.instant('cues.reporte.errorReporte'), timer: 10000});
    }
  }
  async generateZonaPDF(zona: number){
    const grafico = this.graficos[zona - 1];
    var img = undefined;
    if(grafico.type !== typesApex.TABLE){
      const comp = this.grafComp.find(g => g.zona === zona * 10 + 1);
      img = await comp?.exportImgBlob();
    }
    const table = this.exportTablePDF(zona);

    var cont = [
      this.exportTitles(zona),
      table !== undefined ? table : { text: '' },
      img !== undefined ? img : { text: '' }
    ];
    return cont;
  }
  private exportTitles(zona: number){
    return {
      text: [
        {text: this.datosDe(zona, 'tituloZona'), fontSize: 19, bold: true},
        {text: ' • ', fontSize: 19},
        {text: this.subtitles, fontSize: 18, color: '#A7A9AC'}
      ],
      margin: [ 0, 10, 0, 10 ]
    }
  }
  private exportTablePDF(zona: number){
    const tabla = this.tablaZona[zona - 1];
    if(!tabla){
      return undefined;
    }
    const labels: string[] = this.datosDe(zona, 'labels');
    const encabezado = (text: string) => ({
      text,
      fillColor: '#eeeeee',
      color: '#808080',
      bold: true,
      fontSize: 11,
      alignment: 'left'
    });
    const celda = (text: string) => ({
      text,
      color: '#808080',
      border: [false, true, false, true],
      fontSize: 10,
    });
    const table = {
      headerRows: 1,
      widths: ['*', '*', '*'],
      body: [[encabezado(''), encabezado(tabla.name), encabezado('%')]] as any[]
    };
    labels.forEach((label, i) => {
      table.body.push([celda(label), celda(`${tabla.valores[i]}`), celda(`${tabla.porcentaje[i]}`)]);
    });
    return {
      table,
      width: 480,
      alignment: 'center',
      margin: [0,15,0,15],
      layout: {
        hLineColor: () => '#E0E0E0',
        vLineColor: () => 'white',
      }
    };
  }

  /** Lee los datos de una gráfica por su número de zona (data, labels, axisY o tituloZona). */
  public datosDe(zona: number, campo: 'data' | 'labels' | 'axisY' | 'tituloZona'){
    return (this as any)[campo + zona];
  }
  public cambiarTipo(grafico: GraficoPerfil, type: string){
    grafico.type = type;
  }
  public abrirModal(grafico: GraficoPerfil){
    grafico.ampliado = true;
    if(grafico.type !== typesApex.TABLE){
      // Letra más grande en la vista ampliada, con lo que ya trae el graficador
      setTimeout(() => this.grafComp.find(g => g.zona === grafico.zona * 10 + 2)?.changeFontSize(), 200);
    }
  }
  /** Exporta la gráfica como imagen o, en la vista de tabla, como Excel. */
  public exportarGrafico(grafico: GraficoPerfil){
    const titulo = this.translate.instant(this.datosDe(grafico.zona, 'tituloZona'));
    if(grafico.type !== typesApex.TABLE){
      const comp = this.grafComp.find(g => g.zona === grafico.zona * 10 + 1);
      comp?.exportImg(1, { titulo: '', subtitulo: '', nombreArch: titulo });
      return;
    }
    const tabla = this.tablaZona[grafico.zona - 1];
    if(!tabla){
      return;
    }
    const labels: string[] = this.datosDe(grafico.zona, 'labels');
    const data = labels.map((label, i) => [label, tabla.valores[i]]);
    this.excel.generateExcel(
      titulo,
      ['', tabla.name],
      data,
      titulo,
      [Aligment.LEFT, Aligment.RIGHT],
      [FormatText.TEXT, FormatText.NUMBER]
    );
  }

}
